
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/kenshui30/articles",
      function () {
        return require("private-next-pages/special/kenshui30/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/kenshui30/articles"])
      });
    }
  